import { render } from "./SignText.vue?vue&type=template&id=b7915df4"
import script from "./SignText.vue?vue&type=script&lang=js"
export * from "./SignText.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/SignText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7915df4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7915df4', __exports__)) {
    api.reload('b7915df4', __exports__)
  }
  
  module.hot.accept("./SignText.vue?vue&type=template&id=b7915df4", () => {
    api.rerender('b7915df4', render)
  })

}


export default __exports__